const pk = require('../package.json');

module.exports = {
  sysName: 'ALL DEMO',
  sysVersion: pk.version,
  sysColor: ['#007361', '#44dfc7']
}